const blacklist = ['de', 'del'];

function titleizeWord(word: string): string {
  return `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`;
}

function titleize(string: string): string {
  return string
    .split(' ')
    .map((word) => (word.length > 1 && !blacklist.includes(word) ? titleizeWord(word) : word))
    .join(' ');
}

export { titleize };
